import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTasks, faSmile, faBusinessTime, faMugHot, faCode} from '@fortawesome/free-solid-svg-icons';
import Header from './../shared/Header';
import { About } from './../../elements/AboutElements';
import TechStack from './../shared/TechStack';

const AboutContent = () => {


    const aboutImg = useStaticQuery(graphql`
        query aboutImage {
            allContentfulAsset(filter: {
                file: {
                    fileName: {
                        eq: "princerathupa.jpg"
                    }
                }
            }){
                edges {
                    node {
                        file {
                            url
                        }
                    }
                }
            }
        }
    `)

    return (
        <About>
            <Header page="About Prince Rathupa"/>
            <div className="container">
                <div className="top-wrapper">
                    <div className="left-content">
                        <h2>Hi, I am Prince <span className="effect">Rathupa</span></h2>
                        <span>Nice to meet you</span>
                        <div className="about-content-box">
                            <p>
                                I am a creative Full Stack Web Developer based in Johannesburg. I discovered my love for the digital world when I first signed up for the Mxit app back in 2010.
                                Ever since that moment I have been inspred to help built one of the great online communities in the world. I am a problem solver, hard worker and independent individual
                                who can handle any amount of work on his own. I enjoy building usable, responsive, interactive and fast web applications with the latest web technologies.
                            </p>
                        </div>
                        <div className="about-content-box">
                            <p>
                                I started my professional career back in 2017 and I was blessed enough to work on some of the best news websites in South Africa.
                                I built my first professional website for a Investment Summit event ran by the Business Day and Financial Mail. The launch of the website has been
                                one of my great career highlights and ever since that day I have been inspired to improve my skills and continue learning new technologies.
                            </p>
                        </div>
                        <div className="about-content-box">
                            <p>
                                If you have a website idea in mind or you need to improve your current website, feel free to contact me 
                                and if you are looking for a professional Full Stack Web Developer, you can check my tech stack below and I am willing to learn new technologies to improve my skills 
                             </p>
                        </div>
                    </div>
                    <div className="right-content" style={{backgroundImage: `url(${aboutImg.allContentfulAsset.edges[0].node.file.url})`}}>
                    </div>
                </div>
                <div className="facts">
                    <div className="achievement">
                        <FontAwesomeIcon icon={faTasks} />
                        <h3 className="effect">20+</h3>  
                        <p>Projects Completed</p>
                    </div>
                    <div className="achievement">
                    <FontAwesomeIcon icon={faSmile} />
                    <h3 className="effect">10+</h3>  
                    <p>Satisfied Clients</p>
                    </div>
                    <div className="achievement">
                        <FontAwesomeIcon icon={faBusinessTime} />
                        <h3 className="effect">3+</h3>  
                        <p>Years Job Experience</p>
                    </div>
                    <div className="achievement">
                        <FontAwesomeIcon icon={faMugHot} />
                        <h3 className="effect">100+</h3>  
                        <p>Cups Of Rooibos Tea</p>
                    </div>
                    <div className="achievement">
                        <FontAwesomeIcon icon={faCode} />
                        <h3 className="effect">5000+</h3> 
                        <p>Lines Of Code</p>
                    </div>
                </div>
            </div>
            <TechStack />
        </About>
    )
    
}

export default AboutContent;